import React, { FC, useMemo } from "react";
import { AnswerStatuses, IUserForMeetingPlaner, PLANNER_DATE_FORMAT, getDateInUserTimezone, setClass } from "../../../utils";
import { format } from "date-fns";
import { Cross } from "../../svgs";
import { Avatar } from "@mui/material";
import { ConfirmationStatus } from "../../confirmationStatus";

interface HeaderMemberProps {
  member: IUserForMeetingPlaner;
  offset: number;
  initiatorId: number;
  updateSelectedMembers: (id: number) => void;
}

export const HeaderMember: FC<HeaderMemberProps> = ({ member, offset, initiatorId, updateSelectedMembers }) => {
  const tooltip = useMemo(() => 
    (member?.confirmation?.answerStatus === AnswerStatuses.COUNTER_OFFER 
      && `Предлагаю в ${format(getDateInUserTimezone(member?.confirmation?.offeredTime, offset), PLANNER_DATE_FORMAT)}`
    ), [offset]
  );

  return (
    <div
      key={member.id}
      title={tooltip}
      className="day member"
    >
      <Cross
        divClassName="delete-member"
        width={14}
        height={14}
        onClick={() => updateSelectedMembers(member.id)}
      />
      <div className="photo">
        <Avatar
          sx={{ height: 26, width: 26 }}
          src={member.img}
        />
      </div>
      <div className="info">
        <div className="name">
          {member.fullName}
        </div>
        <div className="position">
          {member.position}
        </div>
        <ConfirmationStatus 
          confirmationUser={member?.confirmation}
          userId={member.id}
          initiatorId={initiatorId}
          className={setClass('confirmation-status', member?.confirmation?.offeredTime && 'offered-time')} 
          offset={offset}
        />
      </div>
    </div>
  )
}